import { render, staticRenderFns } from "./KPaginatedAutocomplete.vue?vue&type=template&id=deb02188&"
import script from "./KPaginatedAutocomplete.vue?vue&type=script&lang=ts&"
export * from "./KPaginatedAutocomplete.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports